module.exports = __webpack_public_path__ + "img/2.824a6810.png";